/* global I18n */

import React from "react"
import {use_configuration} from "./configuration_provider"
import SliderControl from "./slider_control"
import AdvancedSettings from "./advanced_settings"

function StudyModeConfigurations({quiz}) {
  const {configuration, update_configuration} = use_configuration()
  const {duration} = configuration

  return (
    <div className="controls">
      <SliderControl
        title={I18n.t("js.quiz_mode_selector.duration.title")}
        text={I18n.t("js.quiz_mode_selector.duration.text")}
        min={5}
        max={30}
        step={5}
        value={duration}
        on_change={duration => update_configuration({duration})}
      />
      <AdvancedSettings quiz={quiz} />
    </div>)
}

export default StudyModeConfigurations
